/** SSE frame parser. Accumulates chunks and emits complete frames. */

export interface SseFrame {
  event: string;
  data: string;
}

export interface ParseResult {
  frames: SseFrame[];
  remainder: string;
}

export function parseSseFrames(buffer: string): ParseResult {
  const frames: SseFrame[] = [];
  const parts = buffer.split('\n\n');
  const remainder = parts.pop() ?? '';

  for (const raw of parts) {
    if (raw.length === 0) continue;
    if (raw.startsWith(':')) continue; // heartbeat comment

    let event = 'message';
    const dataLines: string[] = [];
    for (const line of raw.split('\n')) {
      if (line.startsWith('event: ')) {
        event = line.slice('event: '.length).trim();
      } else if (line.startsWith('data: ')) {
        dataLines.push(line.slice('data: '.length));
      }
    }
    frames.push({ event, data: dataLines.join('\n') });
  }

  return { frames, remainder };
}
